import { InfoOutlined, AutoAwesome, AddRounded, FeaturedPlayList } from '@mui/icons-material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { website } from '../config/config';

const Footer = () => {
      const [fabOpen, setFabOpen] = useState(false);

      return (
            <>
                  <footer className="forge-footer">
                        <div className="forge-container">
                              <div className="footer-bottom">
                                    <span>© 2026 {website}. Simple. Clean. Built for you.</span>
                                    <div className="footer-links">
                                          <Link to="/privacy">Privacy</Link>
                                          <Link to="/terms">Terms</Link>
                                          <Link to="/about">About</Link>
                                    </div>
                              </div>
                        </div>
                  </footer>

                  {/* FAB Group */}
                  <div className={`fab-group ${fabOpen ? 'open' : ''}`}>

                        <Link to="/whats-new" className="fab-item fab-whatsnew" onClick={() => setFabOpen(false)}>
                              <AutoAwesome />
                              <span className="fab-tooltip">What's New</span>
                        </Link>

                        <Link to="/features" className="fab-item fab-features" onClick={() => setFabOpen(false)}>
                              <FeaturedPlayList />
                              <span className="fab-tooltip">features</span>
                        </Link>

                        <Link to="/about" className="fab-item fab-about" onClick={() => setFabOpen(false)}>
                              <InfoOutlined />
                              <span className="fab-tooltip">About</span>
                        </Link>

                        <button className="fab-main" onClick={() => setFabOpen(!fabOpen)}>
                              <AddRounded className="fab-icon" />
                        </button>

                  </div>
            </>
      );
}

export default Footer;
